
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 35h26v-5l-8.037-3.196a1.085 1.085 0 01-.629-.981v-1.171c0-.264.079-.529.275-.718 1.297-1.397 2.161-3.474 2.397-4.078a.818.818 0 01.197-.302c.235-.19.628-.68.903-1.85.236-1.134-.196-1.776-.471-2.078a.732.732 0 01-.236-.529v-4.871c-.51-2.795-2.24-4.117-3.969-4.72-1.847-.68-5.147-.68-7.034.037-1.65.642-3.34 1.926-3.811 4.683v4.871a.732.732 0 01-.236.53c-.275.301-.707.943-.472 2.076.236 1.17.668 1.662.904 1.85a.818.818 0 01.197.303c.235.642 1.1 2.643 2.357 4.04.197.227.315.53.315.831v1.02c0 .491-.275.906-.747 1.133L7 30v5z","fill":"currentColor"}})])
          )
        }
      }
    